export function OutlineCommentIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5.9944V13.5044C21 15.16 19.6608 16.4988 18.0048 16.4988H12L5.9952 21V16.4988C4.3488 16.4988 3 15.16 3 13.5044V5.9944C3 4.33884 4.3488 3 5.9952 3H18.0048C19.6608 3 21 4.33884 21 5.9944Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
